module.exports = __webpack_public_path__ + "img/model_37.cba717db.jpg";